import React, { Component } from 'react';
import CanvasJSReact from '../../../assets/js/CanvasCharts/canvasjs.react';
var CanvasJSChart = CanvasJSReact.CanvasJSChart;
 
class ChartWidgets extends Component {
	constructor(props) {
		super(props);
		this.state = {
			dataPoints: []
		}
	}
	
	componentDidMount(){
	}

	getDataPoints = () => {
		let bindData = this.props.widgetItem.bind
		if(bindData.hasOwnProperty('data')){
			this.setState({
				dataPoints: bindData.data.dataPoints
			})
		}
	}

	getDynamicData = (bindData) => {
        let chartPoints = [];
		let widgetType = this.props.widgetItem.widgetType;
		let animationAngle = this.props.widgetItem.animationAngle;
		let fontSize = this.props.widgetItem.fontSize;
		let markerSize = this.props.widgetItem.markerSize;
        for (let data of bindData) {
            let tempChartObject = {
                    type: (widgetType !== null && widgetType !== undefined) ? widgetType.toLowerCase() : '',
                    startAngle: (animationAngle !== null && animationAngle !== undefined) ? animationAngle : '',
                    showInLegend: this.props.widgetItem.chartOptions.filter(e => e === "showInLegend").length > 0,
                    indexLabelFontFamily: "tahoma",
                    legendText : "{label}",
                    lineThickness: 1,
                    fillOpacity: 0.7,
                    indexLabelFontSize: (fontSize !== null && fontSize !== undefined) ? fontSize : '',
                    dataPoints: data.dataPoints !== undefined ? data.dataPoints : [],
                    name : data.name !== undefined ? data.name : "",
                    markerSize: (markerSize !== undefined && markerSize !== undefined) ? markerSize : 10,
            }
            if(widgetType === "Pie" || widgetType === "Doughnut"){
                delete tempChartObject["name"]; 
            }else{
                delete tempChartObject["legendText"]; 
            }
            chartPoints.push(tempChartObject);
        }
        return chartPoints;
    }

	toggleDataSeries =(e)=>{
		if (typeof(e.dataSeries.visible) === "undefined" || e.dataSeries.visible) {
			e.dataSeries.visible = false;
		}
		else{
			e.dataSeries.visible = true;
		}
		this.chart.render();
	}

	render() {
		let getBind = this.props.widgetItem.bind
		let bindData;
		let options = {};
		if (getBind.hasOwnProperty('data') && getBind.data !== undefined) {
			bindData = getBind.data;
            let xAxisdata = {};
			let yAxisdata = {};
			if(this.props.widgetItem.axisX !== null && this.props.widgetItem.axisX !== undefined || this.props.widgetItem.axisY !== null && this.props.widgetItem.axisY !== undefined){
				/* xAxis */
				xAxisdata = this.props.widgetItem.axisX
				xAxisdata["labelFontFamily"] = "tahoma";
				xAxisdata["labelFontStyle"] = "normal";
				xAxisdata["labelFontWeight"] = "normal";
				xAxisdata["labelFontSize"] = "12";
				xAxisdata["lineDashType"] = "dot";
				xAxisdata["lineThickness"] = 1;
				/* yAxis */
				yAxisdata = this.props.widgetItem.axisY
				yAxisdata["labelFontFamily"] = "tahoma";
				yAxisdata["labelFontStyle"] = "normal";
				yAxisdata["labelFontWeight"] = "normal";
				yAxisdata["gridColor"] = "#dee2e645";
				yAxisdata["labelFontSize"] = "12";
				yAxisdata["lineDashType"] = "dot";
				yAxisdata["lineThickness"] = 1;
			} else {
				xAxisdata = {}
				yAxisdata = {}
			}
			options = {
				title: {
					text: this.props.widgetItem.title !== null && this.props.widgetItem.title !== undefined ? this.props.widgetItem.title : '',
					fontFamily: "sans-serif",
					fontWeight: "bold",
					horizontalAlign: "left",
					fontSize: 25,
					margin: 25,
				},
				legend: {
					markerMargin: 8,
					fontFamily: "tahoma",
					fontSize: 12,
					cursor: "pointer",
					itemclick: this.toggleDataSeries
				},
				axisX: xAxisdata,
				axisY: yAxisdata,
				gridColor: "lightgray",
				data: this.getDynamicData(bindData),
				exportEnabled: this.props.widgetItem.chartOptions.filter(e => e === "exportEnabled").length > 0,
				animationEnabled: this.props.widgetItem.chartOptions !== null && this.props.widgetItem.chartOptions !== undefined ? this.props.widgetItem.chartOptions.filter(e => e === "animationEnabled").length > 0 : '',
				animationDuration: (this.props.widgetItem.animationDuration !== null && this.props.widgetItem.animationDuration !== undefined && this.props.widgetItem.animationDuration !== "") ? this.props.widgetItem.animationDuration + `000` : '',
				theme: (this.props.widgetItem.theme !== null && this.props.widgetItem.theme !== undefined) ? this.props.widgetItem.theme : '',
				colorSet: "colorShades",
			}

			if(this.props.widgetItem.widgetType === "Pie" || this.props.widgetItem.widgetType === "Doughnut"){
				delete options.legend["itemclick"]
				delete options.legend["cursor"]
			}
		}

		return (
		<div className='card canva-chart p-3'>			
				{options.hasOwnProperty("data") && <CanvasJSChart options={options} onRef={ref => this.chart = ref} /> }
				{Object.keys(options).length === 0 && <span className='text-capitalize font-weight-bold text-danger font12'>widget render failed</span> }
		</div>																						
		);
	}; 
}

export default ChartWidgets;